export const environment = {
  version: "dev",
  production: false,
  EXPLECT_API_URL: "https://dev.api.digimentr.com/",
  EXPLECT_API_KEY: "AcaryuwReX5Mz9NL8GC306sgbgA31hfw2GJUCSpx",
  ENTITY_ID: "2995",
  FREIGHT_FORWARDER_ID: "47",
  AUTH0_LINK: "https://digimentr-dev.eu.auth0.com/oauth/token",
  AUTH0_AUDIENCE: "https://dev.api.digimentr.com/",
  CLIENTID: "Mm7S0nart7VD9V0nrp1FOih1jzaslQdg",
  CLIENTSECRET: "TefwWBiIeIqEXlQA_xEiCCwPzWPM6J4GA7imd-QzXZ1FTZVBA--ORA3YRqaK3Nzv",
  POSTHOG_KEY: "phc_2Ue1BXk2dARl7NgQvfmUz4SgAUZIWSwGfJWtopjTRhk",
  POSTHOG_HOST: "https://eu.i.posthog.com"
}
